import React from 'react';
import { SectionHeading, checkCls } from './ui.jsx';
import { APPEARANCE_COLORS } from './constants.js';

export default function AppearanceSection({ appearance, setAppearance, onRestore }) {
  return (
    <div className="space-y-4">
      <SectionHeading title="Page appearance">
        <button
          type="button"
          data-testid="restore-default-appearance"
          onClick={onRestore}
          className="text-[11px] font-bold text-white/40 hover:text-civix-purpleSoft uppercase tracking-wider transition cursor-pointer"
        >
          RESTORE DEFAULT APPEARANCE
        </button>
      </SectionHeading>

      <div className="grid grid-cols-2 gap-3 text-xs">
        {APPEARANCE_COLORS.map(([key, label, fallback]) => {
          const value = appearance[key] || fallback;
          return (
            <div key={key} className="space-y-1">
              <span className="block text-white/70 font-medium">{label}</span>
              <label className="relative inline-flex items-center gap-2 px-2 py-1 rounded border border-white/15 hover:border-civix-cyan/60 cursor-pointer transition">
                <input
                  type="color"
                  value={value}
                  onChange={(e) => setAppearance({ ...appearance, [key]: e.target.value })}
                  className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                />
                <span className="w-4 h-4 rounded-sm border border-white/30 shrink-0" style={{ backgroundColor: value }} />
                <span data-testid="color-picker-button" className="text-[11px] font-mono uppercase text-white">
                  COLOR: {value}
                </span>
              </label>
            </div>
          );
        })}

        <div className="space-y-1">
          <span className="block text-white/70 font-medium">Time slot appearance</span>
          <div className="flex items-center gap-3 pt-1 text-white/80">
            {[['filled', 'Shadow', 'button-filled'], ['outlined', 'No shadow', 'button-outlined']].map(([val, text, testId]) => (
              <label key={val} data-testid={testId} className="flex items-center gap-1.5 cursor-pointer">
                <input
                  type="radio"
                  name="slotAppearance"
                  value={val}
                  checked={appearance.slotAppearance === val}
                  onChange={() => setAppearance({ ...appearance, slotAppearance: val })}
                  className={checkCls}
                />
                <span>{text}</span>
              </label>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
